<template>
  <div class="w-full h-full ">
    <div class="w-full h-full flex relative">
      <div class="w-full flex-1 flex flex-col relative h-full">
        <div class="w-full space-y-4 py-1">
          <div class="w-full py-3 md:flex space-y-3 md:space-y-0 justify-between px-3 items-center">
            <div>
              <p class="text-3xl">{{ $t('voscommandes') }}</p>
            </div>
            <form @submit.prevent="search" class="md:w-[40%] w-full h-10 bg-red-500 relative rounded-full overflow-hidden ">
              <button :disabled="disable ? true:false" type="submit" class="bg-[#FF9900] w-[20%] h-full absolute right-0 flex items-center">
                <img class="w-3 h-3 mx-auto" src="/icons/search.png" alt="" srcset="">
              </button>
              <div class="h-full flex flex-row items-center w-full rounded-l-full border-[1px] border-gray-200 group-focus-within:border-l-[#FF9900] group-focus-within:border-b-[#FF9900] group-focus-within:border-t-[#FF9900] bg-gray-100 overflow-hidden">
                <select v-model="selectedYear" @change="onYearChange" class="appearance-none bg-transparent  h-full md:w-auto pl-1 text-xs xl:text-base rounded-l-full text-black cursor-pointer">
                  <option v-for="y in yearsRange()" :key="y" :value="y">{{ 'MEL000237' + y.toString() + '-' }}</option>
                </select>
                <input @click="goPageSearch" v-model="matriculeSearch" @keyup="searchRefresh" type="text" required id="input-group-1" class=" bg-gray-100 border pr1 flex-1 border-white text-xs xl:text-base h-full block placeholder-gray-400 focus:outline-none" :placeholder="$t('recherchezmatricule')" :disabled="disable ? true:false"/> 
              </div>
            </form>
          </div>
          <div class="w-full nav-commande  space-x-2 px-1 flex flex-row scrollbar-hide overflow-x-auto">
            <router-link to="/MesCommandes" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('tout') }}</p>
            </router-link> 
            <router-link to="/recus-en-cours-livraison" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('recusencourlivraison') }}</p>
            </router-link>
            <router-link to="/recus-en-cours-recuperation" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('recusencourrecuperation') }}</p>
            </router-link>
            <router-link to="/recus-valides" class="flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('recusvalides') }}</p>
            </router-link>
            <router-link to="/recus-annules" class="flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('recusannules') }}</p>
            </router-link>
          </div>
        </div>
        <div class="h-full w-full flex flex-col ">
          <router-view name="seven"></router-view>
          <div class="w-[98%] mx-auto">
            <p class="font-baskerville font-semibold text-sm">{{ $t('encourlivraison') }}(s): {{ nbrEnCourLivraison }}  &nbsp;  {{ $t('encourrecuperation') }}(s): {{ nbrEnCourRecuperation }}  &nbsp;  {{ $t('valide') }}(s): {{ nbrValide }}  &nbsp;  {{ $t('annule') }}(s): {{ nbrAnnule }}</p>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      nbrEnCourLivraison:0,
      nbrEnCourRecuperation:0,
      nbrValide:0,
      nbrAnnule:0,
      matriculeSearch:'',
      disable:'',
      oldYearSearch:0,
      prefixMatricule:'',
      currentYear: 0,
      selectedYear: 0
    }
  },
  watch: {
    requestNbrEnCourRecuperationCommande: {
        handler(newValue) {
          this.nbrEnCourRecuperation = newValue
        },
        deep: true
      },
      requestNbrEnCourLivraisonCommande: {
        handler(newValue) {
          this.nbrEnCourLivraison = newValue
        },
        deep: true
      },
      requestNbrValideCommande: {
        handler(newValue) {
          this.nbrValide = newValue
        },
        deep: true
      },
      requestNbrAnnuleCommande: {
        handler(newValue) {
          this.nbrAnnule = newValue
        },
        deep: true
      },
    },
  beforeRouteLeave() {
    window.emitter.off("disableInputSearchCommande")
  },
  created(){
    window.emitter.on("disableInputSearchCommande", (value) => {
      this.disable = value
    })
  },
  mounted(){
    this.oldYearSearch = new Date().getFullYear() - 10
    this.currentYear = new Date().getFullYear()
    this.selectedYear = this.requestYearCommande ? this.requestYearCommande : this.currentYear

    this.prefixMatricule = 'MEL000237' + this.selectedYear.toString() + '-'

    if(this.$store.state.factures.length > 0 || this.$store.state.factureValide.length > 0 || this.$store.state.facturesEnCoursLivraison.length > 0){
      this.nbrEnCourLivraison = this.$store.state.nbrEnCourLivraisonCommande
      this.nbrEnCourRecuperation = this.$store.state.nbrEnCourRecuperationCommande
      this.nbrValide = this.$store.state.nbrValideCommande
      this.nbrAnnule = this.$store.state.nbrAnnuleCommande
    }else{
      this.axios.get(this.requestHttp + 'stat-commande-caissiere/'+this.user.relai_id,{
          headers: {
              'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
          },
      }).then(({ data }) => {
          this.$store.state.nbrEnCourLivraisonCommande = data[0]
          this.$store.state.nbrEnCourRecuperationCommande = data[1]
          this.$store.state.nbrValideCommande = data[2]
          this.$store.state.nbrAnnuleCommande = data[3]
      })
      .catch((error) => {
          console.log(error)
      });
    }
  },
  methods:{
    goPageSearch(){
      this.$router.push('/MesCommandes');
    },
    searchRefresh(){
      if(this.matriculeSearch.length == 0){
        window.emitter.emit("searchCommande", [this.matriculeSearch, this.prefixMatricule])
      }
    },
    search(){
      if(this.matriculeSearch.length > 0){
        window.emitter.emit("searchCommande", [this.matriculeSearch, this.prefixMatricule])
      }
    },
    yearsRange(){
      const start = this.oldYearSearch || this.currentYear
      const end = this.currentYear || new Date().getFullYear()
      const years = []
      const s = Math.min(start, end)
      const e = Math.max(start, end)
      for(let y = e; y >= s; y--) years.push(y)
      return years
    },
    onYearChange(){
      this.$store.dispatch('requestYearCommande', this.selectedYear) 
      if(this.selectedYear) this.prefixMatricule = 'MEL000237' + this.selectedYear.toString() + '-'
    }
  },
  computed:{
    requestYearCommande(){
      return this.$store.state.yearCommande
    },
    requestToutMesArticles(){
      return this.$store.state.toutMesArticles
    },
    requestAccueil(){
      return this.$store.state.dataAccueil
    },
    requestHttp(){
      return this.$store.state.api
    },
    requestNbrEnCourLivraisonCommande(){
      return this.$store.state.nbrEnCourLivraisonCommande
    },
    requestNbrEnCourRecuperationCommande(){
      return this.$store.state.nbrEnCourRecuperationCommande
    },
    requestNbrValideCommande(){
      return this.$store.state.nbrValideCommande
    },
    requestNbrAnnuleCommande(){
      return this.$store.state.nbrAnnuleCommande
    },
    user(){
      return this.$store.state.dataAccueil[0]
    },
  }
}
</script>

<style>
  .nav-commande .router-link-exact-active {
    border-color: #FF9900;
    border-bottom-width: 4px;
    color: black;
  }
</style>